import { Injectable } from '@angular/core';
import { Observable, of, Subject, from } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Alarm } from '../models/alarm';
import { MatSnackBar } from '@angular/material';

const jsonHttpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AlarmService {
  getAlarmsBySiteId(arg0: number): any {
    throw new Error("Method not implemented.");
  }

  

  alarms:Alarm[] = [];

  constructor(private http: HttpClient, public snackBar: MatSnackBar) {
    

   }


   getAlarmsBySite(siteId: number){

    this.http.get<[Alarm]>('/core-service/api/alarm?site_id='+ siteId, jsonHttpOptions).pipe(
      catchError(this.handleError<any>('alarms-service'))).subscribe( (alarms:[Alarm]) =>{

        this.alarms = alarms;

      })
   }


  // get rid of this, it has no use now
  getAlarmBySiteIdAndGroupId(site_id: number, group_id: number) {

    var tempAlarms = [];

    this.alarms.forEach(alarm => {


      console.log('match', group_id);


      if(alarm.alarm_group_id == group_id)
        tempAlarms.push(alarm)

    })


    return tempAlarms;

  }
  
  getAlarmByAlarmId(alarmId:number) : Observable <[Alarm]>{
    return this.http.get<[Alarm]>('/core-service/api/alarm?alarm_id='+ alarmId).pipe(
      catchError(this.handleError<any>('alarms-service'))
    );
  }

  getAlarmBySiteId(site_id: number): Observable<[Alarm]> {
    return this.http.get<[Alarm]>('/core-service/api/alarm?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('alarms-service'))
    );
  }

  getAlarmByPortId(port_id: number): Observable<[Alarm]> {
    return this.http.get<[Alarm]>('/core-service/api/alarm?port_nid=' + port_id).pipe(
      catchError(this.handleError<any>('alarms-service'))
    );
  }

  getAlarmByDevId(dev_id: number): Observable<[Alarm]> {
    return this.http.get<[Alarm]>(`/core-service/api/alarm?dev_id=${dev_id}`).pipe(
      catchError(this.handleError<any>('Alarms By DeviceId'))
    );
  }

  getAlarmLogsBySiteId(site_id: number, page: number = 0, size: number = 10): Observable<[Alarm]> {
    return this.http.get<[Alarm]>('/core-service/api/alarm/logs?site_id=' + site_id + `&page=${page}&size=${size}`).pipe(
      catchError(this.handleError<any>('alarms-service'))
    );
  }

  getAlarmLogsByPortId(port_id: number, page: number = 0, size: number = 10): Observable<[Alarm]> {
    return this.http.get<[Alarm]>('/core-service/api/alarm/logs?port_nid=' + port_id + `&page=${page}&size=${size}`).pipe(
      catchError(this.handleError<any>('alarms-service'))
    );
  }

  getAlarmLogsByDevId(dev_id: number, page: number = 0, size: number = 10): Observable<[Alarm]> {
    return this.http.get<[Alarm]>(`/core-service/api/alarm/logs?dev_id=${dev_id}&page=${page}&size=${size}`).pipe(
      catchError(this.handleError<any>('alarms-service'))
    );
  }

  confirmAlarm(alarm: Alarm): Observable<Alarm> {
    return this.http.post<Alarm>('/core-service/api/alarm/confirm', alarm, jsonHttpOptions).pipe(
      catchError(this.handleError<any>('Confirm alarm'))
    );
  }

  clearAlarm(alarm: Alarm): Observable<Alarm> {
    return this.http.post<Alarm>('/core-service/api/alarm/clear', alarm, jsonHttpOptions).pipe(
      catchError(this.handleError<any>('Clear alarm'))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
   
      console.log(`${operation} failed: ${error.message}`);

      // this.snackBar.open(`${operation} failed: ${error.message}`, '', {
      //   duration: 3000,
      // });
   
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
